// Same-origin requests also work in development via the CRA proxy.
export async function authRequest(path, data, signal) {
  const response = await fetch(`/api/${path}`, {
    method: data === undefined ? 'GET' : 'POST',
    credentials: 'include', signal,
    headers: { Accept: 'application/json', ...(data === undefined ? {} : { 'Content-Type': 'application/json' }) },
    ...(data === undefined ? {} : { body: JSON.stringify(data) })
  });
  if (response.status === 204) return null;
  const body = response.headers.get('content-type')?.includes('application/json') ? await response.json() : null;
  if (!response.ok || !body?.usuario?.id) {
    const error = new Error(response.status === 401 ? 'El correo o la contraseña no coinciden.' : response.status === 429 ? 'Demasiados intentos o servicio ocupado. Espera unos minutos.' : 'No se pudo conectar con el acceso del banco. Inténtalo más tarde.');
    error.status = response.status;
    throw error;
  }
  return body.usuario;
}
